module.exports = __webpack_public_path__ + "img/pl.1b9768ef.svg";